import { PaddedSurface } from "App/global-style";
import { PostNumberAndCity } from "Components/Form/PostNumberAndCity";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { TextManager } from "Components/TextContext";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductDetailsFormValues } from "./boatProductDetailsInterfaces";

interface Props {
  formProps: FormikProps<BoatProductDetailsFormValues>;
}

export const CommonFormElementsMotorOrSail = ({
  formProps,
}: Props): React.ReactElement => {
  const { getText } = TextManager;
  return (
    <>
      <PaddedSurface>
        <RadioButtonTrueFalse
          name="trackingSystem"
          id="trackingSystem"
          label={getText("boatform.label.trackingsystem")}
          hint={getText("boatform.hint.trackingsystem")}
          options={getYesOrNoOptions("trackingSystem-yes", "trackingSystem-no")}
          direction="vertical"
          error={getError("trackingSystem", formProps)}
        />
        <RadioButtonTrueFalse
          name="hullAndEngineIdMarked"
          id="hullAndEngineIdMarked"
          label={getText("boatform.label.hullandengineidmarked")}
          options={getYesOrNoOptions(
            "hullAndEngineIdMarked-yes",
            "hullAndEngineIdMarked-no",
          )}
          direction="vertical"
          error={getError("hullAndEngineIdMarked", formProps)}
        />
        <RadioButtonTrueFalse
          name="memberOfRedningsselskapetCoastGuard"
          id="memberOfRedningsselskapetCoastGuard"
          label={getText("boatform.label.memberofredningsselskapetcoastguard")}
          options={getYesOrNoOptions(
            "memberOfRedningsselskapetCoastGuard-yes",
            "memberOfRedningsselskapetCoastGuard-no",
          )}
          direction="vertical"
          error={getError("memberOfRedningsselskapetCoastGuard", formProps)}
        />
        <RadioButtonTrueFalse
          name="usedByYoungerDriver"
          id="usedByYoungerDriver"
          label={getText("boatform.label.usedbyyoungerdriver")}
          hint={getText("boatform.hint.usedbyyoungerdriver")}
          options={getYesOrNoOptions(
            "usedByYoungerDriver-yes",
            "usedByYoungerDriver-no",
          )}
          direction="vertical"
          error={getError("usedByYoungerDriver", formProps)}
        />
      </PaddedSurface>
      <PaddedSurface>
        <RadioButtonTrueFalse
          name="harbourSecurity"
          id="harbourSecurity"
          label={getText("boatform.label.harboursecurity")}
          options={getYesOrNoOptions(
            "harbourSecurity-yes",
            "harbourSecurity-no",
          )}
          direction="vertical"
          error={getError("harbourSecurity", formProps)}
        />
        <PostNumberAndCity
          formProps={formProps}
          label={getText("boatform.label.postnumberandcity")}
          hint={getText("boatform.hint.postnumberandcity")}
        />
      </PaddedSurface>
    </>
  );
};
